/**
 * Route Dependencies
 */
const Portfolios = r => require.ensure([], () => r(require('../components/portfolios/views/Portfolios')), 'portfolios')
const PortfolioEdit = r => require.ensure([], () => r(require('../components/portfolios/views/PortfolioEdit')), 'portfolios')
const PortfoliosShow = r => require.ensure([], () => r(require('../components/portfolios/views/PortfoliosShow')), 'portfolios')
const PortfolioCreate = r => require.ensure([], () => r(require('../components/portfolios/views/PortfolioCreate')), 'portfolios')
const PortfoliosIndex = r => require.ensure([], () => r(require('../components/portfolios/views/PortfoliosIndex')), 'portfolios')
const PortfolioOpex = r => require.ensure([], () => r(require('../components/portfolios/single/PortfolioOpex')), 'portfolios')
const PortfolioGaap = r => require.ensure([], () => r(require('../components/portfolios/single/PortfolioGaap')), 'portfolios')
const PortfolioDebt = r => require.ensure([], () => r(require('../components/portfolios/single/PortfolioDebt')), 'portfolios')
const PortfolioCapex = r => require.ensure([], () => r(require('../components/portfolios/single/PortfolioCapex')), 'portfolios')
const PortfolioIncome = r => require.ensure([], () => r(require('../components/portfolios/single/PortfolioIncome')), 'portfolios')
const PortfolioEquity = r => require.ensure([], () => r(require('../components/portfolios/single/PortfolioEquity')), 'portfolios')
const PortfolioSummary = r => require.ensure([], () => r(require('../components/portfolios/single/PortfolioSummary')), 'portfolios')
const PortfolioCashFlow = r => require.ensure([], () => r(require('../components/portfolios/single/PortfolioCashFlow')), 'portfolios')
const PortfolioDevBudget = r => require.ensure([], () => r(require('../components/portfolios/single/PortfolioDevBudget')), 'portfolios')
const PortfolioClosingCosts = r => require.ensure([], () => r(require('../components/portfolios/single/PortfolioClosingCosts')), 'portfolios')

/**
 * Portfolio Routes
 */
export default {
    path: 'portfolios',
    component: Portfolios,
    children: [
        {
            path: '',
            name: 'portfolios',
            component: PortfoliosIndex
        },
        {
            path: ':portfolioId/edit',
            name: 'portfolios.edit',
            component: PortfolioEdit
        },
        {
            path: 'create',
            name: 'portfolios.create',
            component: PortfolioCreate
        },
        {
            path: ':portfolioId',
            component: PortfoliosShow,
            children: [
                {
                    path: '',
                    name: 'portfolios.summary',
                    component: PortfolioSummary
                },
                {
                    path: 'development-budget',
                    name: 'portfolios.devbudget',
                    component: PortfolioDevBudget
                },
                {
                    path: 'cash-flow',
                    name: 'portfolios.cash_flow',
                    component: PortfolioCashFlow
                },
                {
                    path: 'income',
                    name: 'portfolios.income',
                    component: PortfolioIncome
                },
                {
                    path: 'gaap',
                    name: 'portfolios.gaap',
                    component: PortfolioGaap
                },
                {
                    path: 'opex',
                    name: 'portfolios.opex',
                    component: PortfolioOpex
                },
                {
                    path: 'capex',
                    name: 'portfolios.capex',
                    component: PortfolioCapex
                },
                {
                    path: 'equity',
                    name: 'portfolios.equity',
                    component: PortfolioEquity
                },
                {
                    path: 'debt',
                    name: 'portfolios.debt',
                    component: PortfolioDebt
                },
                {
                    path: 'closing-costs',
                    name: 'portfolios.closing_costs',
                    component: PortfolioClosingCosts
                }
            ]
        }
    ]
}



// WEBPACK FOOTER //
// ./src/router/portfolios.js